<template>
  <div
    class="header-inner__breadcrumbs"
    itemprop="breadcrumb"
    itemscope
    itemtype="https://schema.org/BreadcrumbList">
    <template v-for="(item, i) in breadcrumbItems">
      <BreadcrumbItemLink :key="i" v-if="isLink(item)" :item="item" :index="i+1"/>
      <BreadcrumbItem :key="i" v-else :item="item" :index="i+1"/>
    </template>
  </div>
</template>

<script>
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';

import BreadcrumbItem from '@/components/HeaderInner/BreadcrumbItem.vue';
import BreadcrumbItemLink from '@/components/HeaderInner/BreadcrumbItemLink.vue';

export default {
  name: 'BreadcrumbsBlock',
  components: {
    BreadcrumbItem,
    BreadcrumbItemLink,
  },
  props: {
    items: { type: Array, required: true },
  },
  computed: {
    breadcrumbItems () {
      return [
        {
          url: UrlGenerator.generate('/', {}, this.$i18n.locale),
          label: this.$t('prices.home'),
        },
        ...this.items,
      ];
    },
  },
  methods: {
    isLink (item) {
      return Object.prototype.hasOwnProperty.call(item, 'url');
    },
  },
};
</script>
